import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { ApiService } from '@core/services/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceRegistrationsService {
  constructor(private readonly http: ApiService) {}

  updateHeartbeat(corpPrefix: string, officeCd: string, deviceToken: string): Observable<any> {
    const partitionKey = `corp_${corpPrefix}#office_${officeCd}`;
    return this.http.post(API_ENDPOINT.deviceRegistrations.updateHeartbeat, {
      partitionKey,
      deviceToken
    });
  }

  updateCKDataChangedAt(partitionKey: string, deviceToken: string, ckDataChangedAt: string): Observable<any> {
    return this.http.post(API_ENDPOINT.deviceRegistrations.updateCKDataChangedAt, {
      partitionKey,
      deviceToken,
      ckDataChangedAt
    });
  }
}
